// SAJAFO — combideal-checkbox op de productpagina (nu: zonnekap voor TomTom Rider).
// Staat de checkbox aan, dan gaat het hoofdproduct én de zwarte variant van het
// beschermkapje in ÉÉN /cart/add.js-aanroep het winkelmandje in (zelfde aantal als
// de hoofdbestelling), met een verborgen "_SajafoCombo"-eigenschap erop zodat deze
// regel te onderscheiden is van een gewone, losse aankoop van hetzelfde kapje.
// cart-drawer.liquid / main-cart-items.liquid laten die getagde regel niet als eigen
// rij zien; de prijs "+ € 2,50" wordt in plaats daarvan bij de zonnekap-regel getoond.
// De combiprijs zelf komt niet van hier: dat is een Shopify "Koop X, krijg Y"-korting.
// Zolang het winkelmandje open is, houdt dit script de hoeveelheid van die getagde
// regel altijd gelijk aan het aantal zonnekappen in het winkelmandje (1 kapje per
// zonnekap, niet meer) — dat is meteen de limiet die voorkomt dat er meer goedkope
// kapjes meekomen dan er zonnekappen besteld zijn.
(function () {
  var ZONNEKAP_HANDLE = 'zonnekap-voor-tomtom-rider-navigatie';
  var COMBO_PROPERTY = '_SajafoCombo';
  var syncing = false;

  function getQuantity() {
    var productInfo = document.querySelector('product-info');
    var qtyInput = productInfo && productInfo.quantityInput;
    var value = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return value > 0 ? value : 1;
  }

  function getCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function renderCartSections(response) {
    var cart = getCart();
    if (!cart) return;
    cart.renderContents(response);
    // Dawn's eigen product-form.js ruimt deze klasse op na een add-to-cart
    // (product-form.js regel ~115); omdat wij die flow hier overslaan, moeten we
    // dat zelf doen, anders blijft cart-drawer.js denken dat het mandje nog leeg
    // is en crasht de focus-val zodra de openings-animatie eindigt.
    if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
  }

  function getSections() {
    var cart = getCart();
    if (!cart) return null;
    return cart.getSectionsToRender().map(function (section) { return section.id; });
  }

  function changeLineQuantity(lineKey, quantity, sections) {
    return fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity,
        sections: sections,
        sections_url: window.location.pathname,
      }),
    }).then(function (res) { return res.json(); });
  }

  function syncComboLine(cart) {
    if (syncing) return;

    var items = cart.items || [];
    var zonnekapQty = 0;
    items.forEach(function (item) {
      if (item.handle === ZONNEKAP_HANDLE) zonnekapQty += item.quantity;
    });

    var comboLine = items.filter(function (item) {
      return item.properties && item.properties[COMBO_PROPERTY];
    })[0];
    var currentQty = comboLine ? comboLine.quantity : 0;
    if (zonnekapQty === currentQty || !comboLine) return;

    syncing = true;
    var sections = getSections() || [];
    changeLineQuantity(comboLine.key, zonnekapQty, sections)
      .then(function (response) {
        if (!response.status) renderCartSections(response);
      })
      .catch(function () {})
      .finally(function () {
        syncing = false;
      });
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event.source === 'cart-items' && event.cartData && event.cartData.items) {
          syncComboLine(event.cartData);
        }
      });
    }

    var addon = document.querySelector('[data-se-combo-addon]');
    if (!addon) return;

    var toggle = addon.querySelector('[data-se-combo-toggle]');
    var comboVariantId = addon.getAttribute('data-se-combo-variant-id');
    var form = document.querySelector('product-form form');
    if (!toggle || !comboVariantId || !form) return;

    document.addEventListener(
      'submit',
      function (event) {
        if (event.target !== form) return;
        if (event.defaultPrevented) return;
        if (!toggle.checked) return;

        event.preventDefault();
        event.stopPropagation();

        var productFormEl = form.closest('product-form');
        var submitButton = productFormEl && productFormEl.querySelector('[type="submit"]');
        var qty = getQuantity();
        var mainVariantId = new FormData(form).get('id');

        var payload = {
          items: [
            { id: mainVariantId, quantity: qty },
            {
              id: comboVariantId,
              quantity: qty,
              properties: { '_SajafoCombo': '1' },
            },
          ],
        };
        var sections = getSections();
        if (sections) {
          payload.sections = sections;
          payload.sections_url = window.location.pathname;
        }

        if (submitButton) {
          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
        }

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        })
          .then(function (res) { return res.json(); })
          .then(function (response) {
            if (response.status) return;
            renderCartSections(response);
          })
          .catch(function () {})
          .finally(function () {
            if (submitButton) {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
            }
          });
      },
      true
    );
  }

  document.addEventListener('DOMContentLoaded', init);
})();
